var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckCircleOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.12132 9.24266C7.7308 8.85214 7.09763 8.85214 6.70711 9.24266C6.31658 9.63319 6.31658 10.2664 6.70711 10.6569L8.82843 12.7782C9.21895 13.1687 9.85212 13.1687 10.2426 12.7782L13.7782 9.24266C14.1687 8.85214 14.1687 8.21897 13.7782 7.82845C13.3877 7.43792 12.7545 7.43792 12.364 7.82845L9.53553 10.6569L8.12132 9.24266Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10Z",
  fill: "currentColor"
})));
export { SvgCheckCircleOutline20 as ReactComponent };